import { render, staticRenderFns } from "./RouteDetails.vue?vue&type=template&id=55edd3dc&scoped=true&"
import script from "./RouteDetails.vue?vue&type=script&setup=true&lang=js&"
export * from "./RouteDetails.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RouteDetails.vue?vue&type=style&index=0&id=55edd3dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55edd3dc",
  null
  
)

export default component.exports